import React from "react";
import { ArrowLeftIcon, ArrowRightIcon, IconButton } from "@activecollab/components";
import PropTypes from "prop-types";

export const Navigation = ({ onPrev, onNext, total, current }) => {
  return (
    <div className="ang_preview_header_nav tw-text-theme-900">
      <div className="anchor-box anchor-box--prev">
        <IconButton
          onClick={onPrev}
          variant="text gray"
        >
          <ArrowLeftIcon />
        </IconButton>
      </div>
      <div className="pagination-num pagination-num_left">{current}</div>
      <div className="nav-divider text-center">/</div>
      <div className="pagination-num pagination-num_left">{total}</div>
      <div className="anchor-box anchor-box--next">
        <IconButton
          onClick={onNext}
          variant="text gray"
        >
          <ArrowRightIcon />
        </IconButton>
      </div>
    </div>
  );
};

Navigation.propTypes = {
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  total: PropTypes.number,
  current: PropTypes.number,
};

Navigation.defaultProps = {
  total: 1,
  current: 1,
};
